import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { scrollTo } from '@studiometa/js-toolkit/utils';
import { Frame, Figure, LargeText, Slider } from '@studiometa/ui';
import { isDev } from './config.js';

import Header from './organisms/Header.js';
import Loader from './molecules/Loader.js';
import MaintenanceOverlay from './molecules/MaintenanceOverlay.js';

/**
 * Main App class.
 */
class App extends Base {
  /**
   * App config.
   * @returns {object}
   */
  static config = {
    log: isDev(),
    name: 'App',
    components: {
      LargeText,
      Figure,
      Frame,
      Header,
      Slider,
      Team: (app) => importWhenVisible(() => import('./molecules/Team.js'), 'Team', app),
      SliderCursor: (app) =>
        importWhenVisible(() => import('./organisms/SliderCursor.js'), 'SliderCursor', app),
      Video: (app) => importWhenVisible(() => import('./molecules/Video.js'), 'Video', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion.js'), 'Accordion', app),
      DataSlider: (app) =>
        importWhenVisible(() => import('./organisms/DataSlider.js'), 'DataSlider', app),
      Loader,
      MaintenanceOverlay,
      Downloads: (app) =>
        importWhenVisible(() => import('./molecules/Downloads.js'), 'Downloads', app),
    },
  };

  /**
   * Log a nice message when app is ready.
   * @returns {void}
   */
  mounted() {
    this.$log('mounted 🎉');
  }

  /**
   * Add Scroll to on page change
   */
  onFrameAfterEnter() {
    scrollTo(document.querySelector('#news'));
  }
}

export default createApp(App, document.body);
